import { useEffect, useRef, type ReactNode } from 'react'

export function useRevealAnimation() {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible')
          }
        })
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    )

    const reveals = el.querySelectorAll('.reveal')
    reveals.forEach((r) => observer.observe(r))

    return () => observer.disconnect()
  }, [])

  return ref
}

export function RevealWrapper({ children, className = '' }: { children: ReactNode; className?: string }) {
  const ref = useRevealAnimation()
  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  )
}